import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterTeflCost } from '../../../lib/types/models/center/center-tefl-cost'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterTeflCosts(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.centers.getCenterTeflCosts.url, { id }), query))
    .get<PaginationResponse<CenterTeflCost>>()
}
